import React from "react";
import { Route, Redirect } from "react-router-dom";
import EnterpriseLoyaltyAPI from "../../../api/EnterpriseLoyalty";

const EnterprisePrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = EnterpriseLoyaltyAPI.isAuthenticated();

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/e/login",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default EnterprisePrivateRoute;
